import { Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogTitle, FormHelperText, TextField, Tooltip, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { PlanModel, PlanType, TierModificationType, TierOccurrence } from "../../models/plans.model";
import { validateForm } from "../shared/form-validation";
import { PlansService } from "../../services/plans.service";
import { ToasterType } from "../shared/toaster/toaster.model";
import { ToasterTexts, buttonLabels } from "../shared/constants";
import setToast from "../../helpers/toaster.helper";
import { CancelIcon } from "../../icon";
import ButtonComponent from "../shared/button/button.component";
import { Autocomplete, createFilterOptions } from "@mui/material";
import { ProductType } from "../../models/add-phone-number.model";
import { findIndex } from "lodash";
import { UtilityService } from "../../services/UtilityService";
import { OrganizationModel } from "../../models/organization.model";
import { LoadFeatures, LoadOrganizations } from "../../actions";
import { FeaturesModel } from "../../models/features.model";
import { countries } from "../../helpers/countries";
import AddFeature from "./add.feature.component";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import TierConformationComponent from "./tier-conformation";
import { useDispatch, useSelector } from 'react-redux';
import * as selector from '../../selectors/selectors';

interface IProps {
    isEdit?: boolean;
    isDuplicate?: boolean;
    show: boolean;
    onClose: (isConfirm: boolean) => void;
    refreshPlan: () => void;
    Features: FeaturesModel[];
    Tier?: PlanModel;
    Type: TierModificationType;
    IsMobileDevice: boolean;
}

const AddNewAddOnComponent = (props: IProps) => {
    const dispatch = useDispatch()
    const Organizations: OrganizationModel[] = useSelector(selector.organizations)
    let tier = props.Tier;

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isConfirmBox, setIsConfirmBox] = useState<boolean>(false);
    const [features, setFeatures] = useState<any[]>(tier ? tier.Features : [{ ID: '', Type: 0, Label: '', DisplayOrder: 0, Value: undefined, Validity: 0, Code: "" }]);
    const [symbolsArr, setSymbolsArr] = useState<any[]>(["e", "E", "+", "-"]);
    const [featruesValidity, setFeatruesValidity] = useState<any[]>([]);

    const [name, setName] = useState<string>(tier ? tier.Name : undefined);
    const [price, setPrice] = useState<number>(tier ? tier.Price : undefined);
    const [color, setColor] = useState<string>();
    const [footnote, setFootnote] = useState<string>(tier ? tier.Footnote : undefined);
    const [isDeleted, setIsDeleted] = useState<boolean>(true);
    const [product, setProduct] = useState<number>(tier ? tier.Product : -1);
    const [tierOccurrence, setTierOccurrence] = useState<any>(tier?.TierOccurrence ? tier?.TierOccurrence : undefined);
    const [isPrivate, setIsPrivate] = useState<boolean | -1>(tier ? tier.IsPrivate : -1);
    const [selectedOrganizations, setSelectedOrganizations] = useState<string[]>(!!tier?.SelectedOrganizations ? tier?.SelectedOrganizations : []);
    const [country, setCountry] = useState<string>(tier ? tier.Country : undefined);
    const [planID, setPlanID] = useState<string>(tier ? tier.PlanID : undefined);
    const [errors, setErrors] = useState<any>({ AddonName: '', PlanType: '', Product: '', Price: '', YearlyPrice: '', Type: '', Label: '', Value: '', TierOccurrence: '', FootNote: '', feature: '', SelectedOrganizations: '' });

    useEffect(() => {
        if (Organizations.length === 0) {
            LoadOrganizations(dispatch);
        }
        if (features.length === 0) {
            LoadFeatures(dispatch);
        }
    }, [])

    const onClose = (event?: any, reason?: any) => {
        if (event && reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            // Set 'open' to false, however you would do that with your particular code.
            props.onClose(false);
        }
        if (!event) {
            props.onClose(false);
        }
    }

    const onConfirm = (event) => {
        event.preventDefault();
        setIsConfirmBox(true)
    }

    const onSubmitTier = (event: any) => {
        setIsLoading(true);

        let featureArr = features.map((item) => {
            const { DisplayOrder, ...newItem } = item;
            newItem.Validity = -1;
            newItem.Type = 0;
            return newItem;
        })

        const createObj = (temp: any) => {
            let obj = {};
            Object.keys(temp).forEach(item => {
                const newKey = item.toLowerCase();
                let newValue = temp[item];
                if (item === "Type") {
                    obj = { ...obj, 'featureType': newValue }
                } else if (item === "Value") {
                    if (newValue === -1) {
                        newValue = "-1";
                    }
                    obj = { ...obj, [newKey]: newValue || '0' }
                } else {
                    obj = { ...obj, [newKey]: newValue }
                }
            });
            obj = { ...obj, code: props.Features.find(x => x.ID === temp.ID)?.Code || "" } as any;
            return obj
        }

        const obj = featureArr.map(createObj);

        const data = {
            id: props.isEdit ? planID : undefined,
            name: name?.trim(),
            planType: PlanType.ADD_ON,
            price: Number(price),
            yPrice: Number(0),
            features: obj,
            color: color,
            fNotes: footnote?.trim(),
            isDeleted: TierModificationType.DUPLICATE ? true : isDeleted,
            productType: product,
            occurrenceType: tierOccurrence,
            isPrivate: isPrivate,
            organizationId: selectedOrganizations,
            country: country
        }
        if (validateForm({ Name: name, Price: price, YearlyPrice: "0" }, (errors) => { setErrors({ ...errors, ...errors }) })) {
            if (props.isEdit) {
                PlansService.updatePlans(data).then(() => {
                    setIsLoading(false)
                    props.refreshPlan();
                    setToast(ToasterTexts.TIER_EDIT_SUCCESS.replace('<Name>', data.name), ToasterType.SUCCESS)
                    onClose();
                    setIsLoading(false)
                }).catch(err => {
                    setToast(err.response.data.message, ToasterType.DANGER)
                    setIsLoading(false)
                })
            }
            else {
                PlansService.createPlans(data).then(() => {
                    setIsLoading(false)
                    props.refreshPlan();
                    setToast(ToasterTexts.TIER_ADD_SUCCESS.replace('<Name>', data.name), ToasterType.SUCCESS)
                    onClose();
                }).catch(err => {
                    setIsLoading(false)
                    setToast(err.response.data.message, ToasterType.DANGER)
                })
            }
        }
    }

    const handleFields = (name: any, value: any) => {
        if (name === "feature") {
            if (value) {
                setErrors({ ...errors, feature: "" });
            } else {
                setErrors({ ...errors, feature: "Required" });
            }
        } else {
            validateForm({ [name]: value },
                (errorsNew) => {
                    setErrors({ ...errors, ...errorsNew });
                })
        }
    }

    const handlePrice = (e) => {
        const value = e.target.value;
        const isValidPrice = /^\d{0,5}(\.\d{0,2})?$/.test(value);
        if (isValidPrice || value === '') {
            setErrors({ ...errors, Price: value.length === 0 ? "Required*" : '' });
            setPrice(value);
        }
    }

    const isValidForm = () => {
        const OrgSelected = (isPrivate === true && selectedOrganizations.length > 0 || isPrivate === false && selectedOrganizations.length === 0);
        return Object.values(errors).every(value => value === "") && (!!name && product !== -1 && tierOccurrence !== -1 && !!tierOccurrence && isPrivate !== -1 && OrgSelected && !!country && !!price && (features[0].Label !== '' && !!features[0].Value));
    }

    const handleTierOccurrenceChange = (object: any, value: any) => {
        if (value) {
            const e = { TierOccurrence: "" };
            setTierOccurrence(value?.Value)
            setErrors({ ...errors, ...e });
        }
        else {
            const e = { TierOccurrence: "Required" };
            setErrors({ ...errors, ...e });
            setTierOccurrence(-1)
        }
    };

    const handleNotes = (e: any) => {
        const trimmedValue = e.target.value;
        setFootnote(trimmedValue);
        if (trimmedValue.length > 30) {
            const e = { FootNote: "Footnote should not exceed 30 characters" }
            errors.FootNote = "Footnote should not exceed 30 characters";
            setErrors({ ...errors, ...e });
        }
        else {
            errors.FootNote = ""
            setErrors({ ...errors, ...errors });
        }
    }

    const handlePlanName = (value) => {
        const trimmedValue = value.trim();
        const isWhitespace = trimmedValue.length === 0;
        setErrors({ ...errors, AddonName: value?.length > 30 ? "Name should not exceed 30 characters" : isWhitespace ? "Required*" : "" })
        setName(value)
    }

    const handleProductChange = (e: any, value: any) => {
        if (value) {
            const e = { Product: "" };
            setProduct(value?.Value)
            setErrors({ ...errors, ...e });
        }
        else {
            const e = { Product: "Required" };
            setErrors({ ...errors, ...e });
            setProduct(-1)
        }
    }

    const handlePrivacyChange = (e: any, value: any) => {
        if (value?.Name === 'False') {
            setIsPrivate(value?.Value);
            setSelectedOrganizations([])
            setErrors({ ...errors, SelectedOrganizations: "" })
        }
        else {
            setIsPrivate(value?.Value);
            setErrors({ ...errors, SelectedOrganizations: "" })

        }
    }

    const handleCheckBox = (event: any, values: any) => {
        let val = values.map(x => findIndex(x.ID))
        if (val.find(x => x === -1)) {
            if (Organizations.filter(x => !x.IsDeleted).length === selectedOrganizations.length) {
                setSelectedOrganizations([])
                setIsPrivate(true)
            }
            else {
                setSelectedOrganizations(Organizations.filter(x => !x.IsDeleted).map(x => x.ID))
                setSelectedOrganizations(Organizations.filter(x => !x.IsDeleted).map(x => x.ID))
            }
        }
        else {
            setSelectedOrganizations(values.map(x => x.ID))
        }
        if (values.length === 0) {
            setIsPrivate(true)
            setErrors({ ...errors, SelectedOrganizations: "Required*" })
        }
        if (values.length !== 0) {
            setIsPrivate(true)
            const e = { Product: "" };
            setErrors({ ...errors, SelectedOrganizations: "" })
        }
    };

    const getOrganizations = () => {
        return Organizations.filter(x => !x.IsDeleted)
    }

    const optionRenderer = (defaultprops, option: any, { selected }: any) => {
        const selectAllProps =
            selectedOrganizations.length > 0 && option.value === -1
                ? { checked: (getOrganizations().length === selectedOrganizations.length) }
                : {};

        return (
            <li {...defaultprops}>
                <Checkbox
                    name="checkbox"
                    className="mr-1"
                    classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
                    indeterminate={option.value === -1 && getOrganizations().length - 1 === selectedOrganizations.length}
                    checked={selected}
                    {...selectAllProps}
                />
                <div className={`my-auto t-align-left`}> {props.IsMobileDevice ? UtilityService.trimMessage(option?.Name, 20) : option?.Name} </div>
            </li>
        )
    }

    const handleFeatureCompletion = (id: string, isValid: boolean, feature?: any) => {
        setFeatruesValidity([...featruesValidity.filter(x => x.id !== id), { id, isValid }])
        if (feature) {
            setFeatures([feature])
        }
    }

    const onCloseConfirmation = () => {
        setIsConfirmBox(false);
    }

    let products = [{ Name: "Landline Texting", Value: ProductType.LANDLINE_TEXTING }, { Name: "VoIP Texting", Value: ProductType.VOIP_TEXTING }, { Name: "MS Teams Calling and Texting", Value: ProductType.MS_TEAMS_TEXTING }, { Name: "Toll-Free Texting", Value: ProductType.TOLL_FREE_TEXTING }];
    let Privacy = [{ Name: "False", Value: false }, { Name: "True", Value: true }]
    let tierOccurrences = [{ Name: "One Time", Value: TierOccurrence.ONE_TIME }, { Name: "Recurring", Value: TierOccurrence.RECURRING }];

    const Autofilter = createFilterOptions();

    const handleKeyPress = (e) => {
        if (
            (e.key === 'e' || e.key === 'E' || e.key === '-' || e.key === '+')
        ) {
            e.preventDefault();
        }
    }

    return <>
        {
            isConfirmBox && <TierConformationComponent isLoading={isLoading} onSubmit={onSubmitTier} Organizations={Organizations} name={name} price={price} footnote={footnote} product={product}
                country={country} show={isConfirmBox} products={products} Features={props.Features} features={features} IsPrivate={isPrivate} tierOccurrence={tierOccurrence} selectedOrganizations={selectedOrganizations} onClose={onCloseConfirmation} />
        }
        <Dialog open={props.show} fullWidth maxWidth="md"
            BackdropProps={{ style: { backgroundColor: "transparent" } }} className={"dialogue-shadow"}
            disableEscapeKeyDown onClose={onClose} aria-labelledby="customized-dialog-title">
            <form onSubmit={onConfirm} action="" noValidate className=""
                autoComplete="off">
                <DialogTitle className="dialog-header p-2">
                    <div className="h2-regular color-text-field-font d-flex" id="customized-dialog-title">
                        {props.isEdit ? buttonLabels.EDIT_ADDON_PLAN : props.isDuplicate ? buttonLabels.DUPLICATE_ADDON_PLAN : buttonLabels.ADD_NEW_ADDON_PLAN}
                        <Tooltip title='Close' placement='bottom'>
                            <span className="ml-auto">
                                <CancelIcon className={"c-pointer"} onClick={onClose} />
                            </span>
                        </Tooltip>
                    </div>
                </DialogTitle>
                <div className={"bb-primary-background-pink-4 mx-2"}></div>
                <DialogContent className={`scroll pb-0 px-1`} style={{ height: "32rem" }} >
                    <div className="d-flex flex-direction">
                        <div className="d-flex flex-direction-row justify-between">
                            <div className="w-p-100">
                                <TextField fullWidth id="outlined-basic-1" margin="dense" label="Add-on Name *" variant="outlined" name="Name" value={name}
                                    size='small'
                                    disabled={props.Type === TierModificationType.EDIT}
                                    onChange={(e) => { handlePlanName(e.target.value) }}
                                    InputProps={{
                                        classes: { input: `${props.IsMobileDevice ? 'h2' : 'h4-regular'} color-text-field-font` },
                                        style: {
                                            width: "100%",
                                            backgroundColor: props.Type === TierModificationType.EDIT ? 'lightgrey' : 'transparent',
                                        }
                                    }}
                                    className="mx-1 my-1 w-fill" />
                                <FormHelperText className={`${props.IsMobileDevice ? 'h5' : 'h5-regular'} mx-1 color-primary-danger t-align-right mr-1`}>
                                    {errors.AddonName}
                                </FormHelperText>
                            </div>
                            <div className="w-p-100">
                                <TextField id="outlined-basic-3" margin="dense" label="Footnote" variant="outlined" size='small'
                                    name="footNote" value={footnote} onChange={handleNotes}
                                    InputProps={{ classes: { input: `${props.IsMobileDevice ? 'h2' : 'h4-regular'} color-text-field-font` } }}
                                    className="mx-1 my-1 w-fill" />
                                <FormHelperText className="h5 mx-1 color-primary-danger t-align-right">
                                    {errors.FootNote}
                                </FormHelperText>
                            </div>
                        </div>
                        <div className="d-flex flex-direction-row justify-between">
                            <div className="w-p-50 d-flex flex-direction justify-between">
                                <Autocomplete
                                    size="small"
                                    className={"mx-1 my-1 w-fill"}
                                    classes={{ input: `${'h4-regular'} color-text-field-font`, paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                    options={products}
                                    getOptionLabel={(option: any) => option.Name}
                                    onChange={handleProductChange}
                                    value={products.find(x => x.Value === product)
                                        || { Name: "", Value: 0 }
                                    }
                                    renderOption={(defaultprops, option: any) => (
                                        <li {...defaultprops}>
                                            <span className={`${'h4-regular'} c-pointer color-menu-list-font-color p-2 d-flex justify-between w-p-90`}>
                                                {option.Name}
                                            </span>
                                        </li>
                                    )}
                                    renderInput={(params) => <TextField {...params} name="product" required variant="outlined" label="Select Product" placeholder="Select Product" />}
                                />
                                <FormHelperText className={`${'h5-regular'} color-primary-danger t-align-right mr-1`}>
                                    {errors.Product}
                                </FormHelperText>


                            </div>
                            <div className="w-p-50 d-flex flex-direction justify-between">
                                <Autocomplete
                                    size="small"
                                    className={"mx-1 my-1 w-fill"}
                                    classes={{ input: `${'h4-regular'} color-text-field-font`, paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                    options={tierOccurrences}
                                    getOptionLabel={(option: any) => option.Name}
                                    onChange={handleTierOccurrenceChange}
                                    value={tierOccurrences.find(x => x.Value === tierOccurrence)
                                        || { Name: "", Value: -1 }
                                    }
                                    renderOption={(defaultprops, option: any) => (
                                        <li {...defaultprops}>
                                            <span className={`${'h4-regular'} c-pointer color-menu-list-font-color p-2 d-flex justify-between w-p-90`}>
                                                {option.Name}
                                            </span>
                                        </li>
                                    )}
                                    renderInput={(params) => <TextField {...params} name="TierOccurrence" required variant="outlined" label="Select Tier Occurrence" placeholder="Select Tier Occurrence" />}
                                />
                                <FormHelperText className={`${'h5-regular'} color-primary-danger t-align-right mr-1`}>
                                    {errors.TierOccurrence}
                                </FormHelperText>
                            </div>
                        </div>

                        <div className="d-flex flex-direction-row justify-between">
                            <div className="w-p-100">
                                <Autocomplete
                                    size="small"
                                    className={"mx-1 my-1 w-fill"}
                                    classes={{ input: `${'h4-regular'} color-text-field-font`, paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                    options={Privacy}
                                    getOptionLabel={(option: any) => option.Name}
                                    onChange={handlePrivacyChange}
                                    value={Privacy.find(x => x.Value === isPrivate)}
                                    renderOption={(defaultprops, option: any) => (
                                        <li {...defaultprops}>
                                            <span className={`${'h4-regular'} c-pointer color-menu-list-font-color p-2 d-flex justify-between w-p-90`}>
                                                {option.Name}
                                            </span>
                                        </li>
                                    )}
                                    renderInput={(params) => <TextField {...params} name="Privacy" required variant="outlined" label="Is Private" placeholder="Public" />}
                                    disableClearable={true}
                                />
                            </div>
                            <div className="w-p-100">
                                {
                                    isPrivate === true ?
                                        <div>
                                            <Autocomplete
                                                ListboxProps={
                                                    {
                                                        style: {
                                                            maxHeight: '16rem',
                                                        }
                                                    }
                                                }
                                                multiple
                                                limitTags={2}
                                                size="small"
                                                disabled={isPrivate === false || isPrivate === -1}
                                                disableCloseOnSelect={true}
                                                options={Organizations.filter(x => !x.IsDeleted)}
                                                getOptionLabel={(option: any) => option.Name}
                                                classes={{ input: `${'h4-regular'} color-text-field-font`, paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                                onChange={handleCheckBox}
                                                value={Organizations.filter(x => !x.IsDeleted).filter(x => selectedOrganizations.includes(x.ID))}
                                                filterOptions={(options: any[], params: any) => {
                                                    if (Organizations.filter(x => !x.IsDeleted).length > 0) {
                                                        const filtered = Autofilter(options, params);
                                                        return [{ Name: "Select all", value: -1 }, ...filtered];
                                                    } else if (Organizations.filter(x => !x.IsDeleted).length === 0) {
                                                        const filtered = Autofilter(options, params);
                                                        return [...filtered];
                                                    }
                                                    else { return options; }
                                                }}
                                                renderOption={optionRenderer}
                                                renderTags={(value, getTagProps) =>
                                                    value.map((option, index) => (
                                                        <Chip
                                                            classes={{
                                                                colorPrimary: "custom-color-chip-2",
                                                                avatarColorPrimary: "custom-chip-avatar",
                                                            }}
                                                            color='primary'
                                                            label={option.Name}
                                                            {...getTagProps({ index })}
                                                        />
                                                    ))
                                                }
                                                renderInput={(params) => <TextField {...params} name="SelectOrganization" required variant="outlined" label="Select Organization" />}
                                                className={"mx-1 my-1 w-fill"}
                                            />
                                            <FormHelperText className="h5 color-primary-danger t-align-right">
                                                {errors.SelectedOrganizations}
                                            </FormHelperText>
                                        </div> : null
                                }
                            </div>
                        </div>

                        <div className="d-flex flex-direction-row justify-between">
                            <div className="w-p-50">
                                <Autocomplete
                                    size="small"
                                    className={"mx-1 my-1 w-fill"}
                                    classes={{ input: `${'h4-regular'} color-text-field-font`, paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                    options={countries}
                                    getOptionLabel={(option: any) => option.Name}
                                    onChange={(event: any, value: any | null) => {
                                        if (value) {
                                            setCountry(value.ISO);
                                            const e = { CountryError: "" }
                                            setErrors({ ...errors, ...e })
                                        }
                                        else {
                                            setCountry("");
                                            const e = { CountryError: "Required*" }
                                            setErrors({ ...errors, ...e })
                                        }
                                    }}
                                    value={countries.find(x => x.ISO === country)}
                                    renderOption={(defaultprops, option: any) => (
                                        <li {...defaultprops}>
                                            <span className={`${'h4-regular'} c-pointer color-menu-list-font-color p-2 d-flex justify-between w-p-90`}>
                                                {option.Name}
                                            </span>
                                        </li>
                                    )}
                                    renderInput={(params) => {
                                        return (<TextField {...params} name="country" required variant="outlined" label="Select Country" placeholder="Select Country" inputProps={{ ...params.inputProps, autoComplete: 'new-password' }} />)
                                    }}
                                />
                                <FormHelperText className={`${'h5-regular'} color-primary-danger t-align-right mr-1`}>
                                    {errors.CountryError}
                                </FormHelperText>
                            </div>

                            <div className="w-p-50">
                                <TextField required className="mx-1 my-1 w-fill" type="number" id="outlined-basic" size='small' name="Price" value={price}
                                    margin="dense" label={"Price"} variant="outlined"
                                    onChange={(e) => handlePrice(e)}
                                    onKeyPress={(e) => handleKeyPress(e)}
                                />
                                <FormHelperText className={`${'h5-regular'} color-primary-danger t-align-right mr-1`}>
                                    {errors.Price}
                                </FormHelperText>
                            </div>
                        </div>

                        <DndProvider backend={HTML5Backend}>
                            <div className="w-p-100 d-flex flex-direction justify-between">
                                <Typography className={`h2-regular color-feature-title mt-1 mx-1`}>
                                    Feature*</Typography>
                                <AddFeature
                                    key={0}
                                    index={0}
                                    {...features[0]}
                                    onRemove={() => { }}
                                    symbolsArr={symbolsArr}
                                    Features={features}
                                    allFeaturesData={props.Features}
                                    isAddon={true}
                                    handleFields={handleFields}
                                    name={"Feature"}
                                    errors={errors}
                                    FeatureDragStarted={false}
                                    HandleFeatureDragStart={() => { }}
                                    HandleFeatureHover={() => { }}
                                    DraggingFeatureID={""}
                                    IsMobileDevice={false}
                                    HandleFeatureChangeCompletion={handleFeatureCompletion}
                                />
                            </div>
                        </DndProvider>

                    </div>
                </DialogContent>

                <DialogActions className={`p-2`}>
                    <ButtonComponent OnClick={() => onClose()} ButtonLabel={buttonLabels.CANCEL} ClassName={"ml-auto mr-1"} Variant={"secondary-btn-small"} />
                    <ButtonComponent Type={"submit"} Loading={isLoading}
                        ButtonLabel={props.isEdit ? buttonLabels.UPDATE_ADD_ON_PLAN : props.isDuplicate ? buttonLabels.DUPLICATE_ADDON_PLAN : "Create Add-On"}
                        ClassName={"pl-4 pr-4"}
                        Variant={isValidForm() ? "primary-btn-small" : "disabled-btn-small"} />
                </DialogActions>
            </form>
        </Dialog>
    </>
}

export default AddNewAddOnComponent;
